// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriversUI_wrapper__obJwE {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.DriversUI_header__0BBCu {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.DriversUI_back__WLtZC {
  display: flex;
  align-items: center;
  color: var(--orange);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 1.625rem;
}

.DriversUI_loader__h7qtx {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.DriversUI_back__WLtZC:hover {
  color: var(--orange);
}

.DriversUI_backButton__jK22g {
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--orange);
  color: white;
  margin-right: 1rem;
}

.DriversUI_title-box__9p\\+sj {
  font-size: 1.1em;
  color: black;
  padding-top: 0.6em;
}

.DriversUI_splitLayout__rEdXz {
  display: flex;
  gap: 1.5rem;
  height: calc(100vh - 13.75rem);
  margin-top: 1rem;
  overflow: hidden;
}

.DriversUI_sidebar__xf6Jk {
  width: 20rem;
  min-width: 20rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
}

.DriversUI_mapContainer__ea6wF {
  flex: 1 1;
  border-radius: 0.75rem;
  overflow: hidden;
  background-color: #fafafa;
  border: 0.0625rem solid #eaeaea;
  position: relative;
}

/* Filter Cards (KPI Style) */

.DriversUI_filterGrid__Dso5P {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.DriversUI_filterCard__lHTlk {
  background-color: white;
  border: 0.0625rem solid #eaeaea;
  border-radius: 0.875rem;
  padding: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.02);
  gap: 1rem;
}

.DriversUI_filterCard__lHTlk:hover {
  border-color: #d9d9d9;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
  transform: translateY(-0.125rem);
}

.DriversUI_filterCardActive__Fd7Qr {
  border-color: var(--orange);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
}

.DriversUI_driverCardSelected__XG1dA {
  border-color: var(--orange) !important;
  background-color: #fff7e6 !important;
  box-shadow: 0 0.25rem 0.75rem rgba(250, 140, 22, 0.15) !important;
}

.DriversUI_filterCardInfo__lOTkg {
  display: flex;
  align-items: center;
  gap: 0.875rem;
}

.DriversUI_layerControlsMobile__O74dJ {
  display: none;
}

.DriversUI_floatingControlsDesktop__nnoK9 {
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
  margin: 10px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
}

.DriversUI_layerControl__P4C3A {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.DriversUI_layerLabel__P2qRb {
  font-size: 0.8125rem;
  color: #595959;
  font-weight: 500;
}

.DriversUI_filterIcon__9PMIf {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.DriversUI_filterIcon__9PMIf svg {
  width: 1.5rem;
  height: 1.5rem;
}

.DriversUI_filterTitle__U3cNH {
  font-size: 0.875rem;
  font-weight: 500;
  color: #595959;
}

.DriversUI_filterCount__7cyMT {
  font-size: 1.125rem;
  font-weight: 600;
  color: #262626;
}

/* Specific Colors */

.DriversUI_filterOnline__r2V7i .DriversUI_filterIcon__9PMIf { background-color: #f6ffed; color: #52c41a;
}

.DriversUI_filterOnline__r2V7i.DriversUI_filterCardActive__Fd7Qr { border-color: #52c41a;
}

.DriversUI_filterWithOrder__lQWxx .DriversUI_filterIcon__9PMIf { background-color: #fff7e6; color: #fa8c16;
}

.DriversUI_filterWithOrder__lQWxx.DriversUI_filterCardActive__Fd7Qr { border-color: #fa8c16;
}

.DriversUI_filterOffline__qzF3C .DriversUI_filterIcon__9PMIf { background-color: #fff1f0; color: #f5222d;
}

.DriversUI_filterOffline__qzF3C.DriversUI_filterCardActive__Fd7Qr { border-color: #f5222d;
}

/* Driver List */

.DriversUI_listContainer__UroQD {
  flex: 1 1;
  overflow-y: auto;
  padding-right: 0.5rem;
}

/* Custom Scrollbar for list */

.DriversUI_listContainer__UroQD::-webkit-scrollbar {
  width: 0.375rem;
}

.DriversUI_listContainer__UroQD::-webkit-scrollbar-track {
  background: transparent;
}

.DriversUI_listContainer__UroQD::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 0.25rem;
}

@keyframes DriversUI_fadeInContent__9h25C {
  from {
    opacity: 0;
    transform: translateY(0.5rem);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.DriversUI_driverList__PfUJA {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  animation: DriversUI_fadeInContent__9h25C 0.3s ease-out;
}

.DriversUI_driverCard__ZABXM {
  background-color: white;
  border: 0.0625rem solid #eaeaea;
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.2s ease-in-out;
}

.DriversUI_driverCard__ZABXM:hover {
  border-color: #d9d9d9;
  background-color: #fafafa;
}

.DriversUI_driverAvatar__clrK4 {
  background-color: #f0f0f0;
  color: #595959;
}

.DriversUI_driverInfo__ljANi {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.DriversUI_driverName__\\+qjW7 {
  font-weight: 600;
  color: #262626;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.DriversUI_statusDot__FdVvJ {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}

.DriversUI_statusDot__FdVvJ.DriversUI_online__0qqpP { background-color: #52c41a;
}

.DriversUI_statusDot__FdVvJ.DriversUI_withOrder__W2ePK { background-color: #fa8c16;
}

.DriversUI_statusDot__FdVvJ.DriversUI_offline__rYxiW { background-color: #f5222d;
}

.DriversUI_driverTime__t9oDC {
  font-size: 0.75rem;
  color: #8c8c8c;
}

.DriversUI_driverTicket__9TwQf {
  font-size: 0.6875rem;
  background-color: #f5f5f5;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  color: #595959;
  border: 0.0625rem solid #d9d9d9;
  margin-top: 0.25rem;
  display: inline-block;
}

/* Responsive Design */

@media (max-width: 992px) {
  .DriversUI_splitLayout__rEdXz {
    flex-direction: column-reverse;
    gap: 1.5rem;
    height: auto;
    overflow: visible;
  }

  .DriversUI_mapContainer__ea6wF {
    width: 100%;
    height: 25rem;
    flex: none;
  }

  .DriversUI_sidebar__xf6Jk {
    width: 100%;
    min-width: 100%;
    height: 31.25rem;
    flex: none;
  }

  .DriversUI_filterGrid__Dso5P {
    flex-direction: row;
    overflow-x: auto;
    padding-bottom: 0.5rem;
    -webkit-overflow-scrolling: touch;
  }

  .DriversUI_filterCard__lHTlk {
    min-width: 8.75rem;
    flex-shrink: 0;
    flex: none;
    padding: 0.75rem;
  }

  .DriversUI_floatingControlsDesktop__nnoK9 {
    display: none;
  }

  .DriversUI_layerControlsMobile__O74dJ {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 0.625rem;
    background: #fafafa;
    border-radius: 0.625rem;
    margin-bottom: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/drivers/styles/DriversUI.module.css"],"names":[],"mappings":"AAAA;EACI,YAAY;EACZ,aAAa;EACb,sBAAsB;AAC1B;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAClC;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACvB;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACX;;AAEA;EACI,oBAAoB;AACxB;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;AACtB;;AACA;EACI,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACtB;;AAEA;EACI,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AACpB;;AAEA;EACI,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AAChB;;AAEA;EACI,SAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACtB;;AAEA,6BAA6B;;AAC7B;EACI,aAAa;EACb,sBAAsB;EACtB,YAAY;AAChB;;AAEA;EACI,uBAAuB;EACvB,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,oDAAoD;EACpD,SAAS;AACb;;AAEA;EACI,qBAAqB;EACrB,iDAAiD;EACjD,gCAAgC;AACpC;;AAEA;EACI,2BAA2B;EAC3B,iDAAiD;AACrD;;AAEA;EACI,sCAAsC;EACtC,oCAAoC;EACpC,iEAAiE;AACrE;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,aAAa;AACjB;;AAEA;EACI,aAAa;AACjB;;AAEA;EACI,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;EACtB,0CAA0C;EAC1C,gDAAgD;AACpD;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACf;;AAEA;EACI,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AACpB;;AAEA;EACI,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AAC3B;;AAEA;EACI,aAAa;EACb,cAAc;AAClB;;AAEA;EACI,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAClB;;AAEA;EACI,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAClB;;AAEA,oBAAoB;;AACpB,8DAA4B,yBAAyB,EAAE,cAAc;AAAE;;AACvE,mEAAiC,qBAAqB;AAAE;;AAExD,iEAA+B,yBAAyB,EAAE,cAAc;AAAE;;AAC1E,sEAAoC,qBAAqB;AAAE;;AAE3D,+DAA6B,yBAAyB,EAAE,cAAc;AAAE;;AACxE,oEAAkC,qBAAqB;AAAE;;AAEzD,gBAAgB;;AAChB;EACI,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACzB;;AAEA,8BAA8B;;AAC9B;EACI,eAAe;AACnB;;AACA;EACI,uBAAuB;AAC3B;;AACA;EACI,mBAAmB;EACnB,sBAAsB;AAC1B;;AAEA;EACI;IACI,UAAU;IACV,6BAA6B;EACjC;;EACA;IACI,UAAU;IACV,wBAAwB;EAC5B;AACJ;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uDAAsC;AAC1C;;AAEA;EACI,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AACpC;;AAEA;EACI,qBAAqB;EACrB,yBAAyB;AAC7B;;AAEA;EACI,yBAAyB;EACzB,cAAc;AAClB;;AAEA;EACI,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACjB;;AAEA;EACI,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACf;;AAEA;EACI,aAAa;EACb,cAAc;EACd,kBAAkB;AACtB;;AACA,sDAAoB,yBAAyB;AAAE;;AAC/C,yDAAuB,yBAAyB;AAAE;;AAClD,uDAAqB,yBAAyB;AAAE;;AAEhD;EACI,kBAAkB;EAClB,cAAc;AAClB;;AAEA;EACI,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;AACzB;;AAEA,sBAAsB;;AACtB;EACI;IACI,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,iBAAiB;EACrB;;EAEA;IACI,WAAW;IACX,aAAa;IACb,UAAU;EACd;;EAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;EACd;;EAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;EACrC;;EAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,gBAAgB;EACpB;;EAEA;IACI,aAAa;EACjB;;EAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACvB;AACJ","sourcesContent":[".wrapper {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.back {\r\n    display: flex;\r\n    align-items: center;\r\n    color: var(--orange);\r\n    font-family: BebasNeue;\r\n    font-weight: 700;\r\n    font-size: 1.625rem;\r\n}\r\n\r\n.loader {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex: 1;\r\n}\r\n\r\n.back:hover {\r\n    color: var(--orange);\r\n}\r\n\r\n.backButton {\r\n    width: 1.875rem;\r\n    height: 1.875rem;\r\n    border-radius: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: var(--orange);\r\n    color: white;\r\n    margin-right: 1rem;\r\n}\r\n.title-box {\r\n    font-size: 1.1em;\r\n    color: black;\r\n    padding-top: 0.6em;\r\n}\r\n\r\n.splitLayout {\r\n    display: flex;\r\n    gap: 1.5rem;\r\n    height: calc(100vh - 13.75rem);\r\n    margin-top: 1rem;\r\n    overflow: hidden;\r\n}\r\n\r\n.sidebar {\r\n    width: 20rem;\r\n    min-width: 20rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    height: 100%;\r\n}\r\n\r\n.mapContainer {\r\n    flex: 1;\r\n    border-radius: 0.75rem;\r\n    overflow: hidden;\r\n    background-color: #fafafa;\r\n    border: 0.0625rem solid #eaeaea;\r\n    position: relative;\r\n}\r\n\r\n/* Filter Cards (KPI Style) */\r\n.filterGrid {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n}\r\n\r\n.filterCard {\r\n    background-color: white;\r\n    border: 0.0625rem solid #eaeaea;\r\n    border-radius: 0.875rem;\r\n    padding: 1rem;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    transition: all 0.2s ease-in-out;\r\n    box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.02);\r\n    gap: 1rem;\r\n}\r\n\r\n.filterCard:hover {\r\n    border-color: #d9d9d9;\r\n    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);\r\n    transform: translateY(-0.125rem);\r\n}\r\n\r\n.filterCardActive {\r\n    border-color: var(--orange);\r\n    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.driverCardSelected {\r\n    border-color: var(--orange) !important;\r\n    background-color: #fff7e6 !important;\r\n    box-shadow: 0 0.25rem 0.75rem rgba(250, 140, 22, 0.15) !important;\r\n}\r\n\r\n.filterCardInfo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.875rem;\r\n}\r\n\r\n.layerControlsMobile {\r\n    display: none;\r\n}\r\n\r\n.floatingControlsDesktop {\r\n    z-index: 10;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n    padding: 0.75rem;\r\n    margin: 10px;\r\n    background: rgba(255, 255, 255, 0.85);\r\n    backdrop-filter: blur(10px);\r\n    -webkit-backdrop-filter: blur(10px);\r\n    border-radius: 0.75rem;\r\n    border: 1px solid rgba(255, 255, 255, 0.5);\r\n    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.layerControl {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.layerLabel {\r\n    font-size: 0.8125rem;\r\n    color: #595959;\r\n    font-weight: 500;\r\n}\r\n\r\n.filterIcon {\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    border-radius: 0.625rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.filterIcon svg {\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n}\r\n\r\n.filterTitle {\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    color: #595959;\r\n}\r\n\r\n.filterCount {\r\n    font-size: 1.125rem;\r\n    font-weight: 600;\r\n    color: #262626;\r\n}\r\n\r\n/* Specific Colors */\r\n.filterOnline .filterIcon { background-color: #f6ffed; color: #52c41a; }\r\n.filterOnline.filterCardActive { border-color: #52c41a; }\r\n\r\n.filterWithOrder .filterIcon { background-color: #fff7e6; color: #fa8c16; }\r\n.filterWithOrder.filterCardActive { border-color: #fa8c16; }\r\n\r\n.filterOffline .filterIcon { background-color: #fff1f0; color: #f5222d; }\r\n.filterOffline.filterCardActive { border-color: #f5222d; }\r\n\r\n/* Driver List */\r\n.listContainer {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding-right: 0.5rem;\r\n}\r\n\r\n/* Custom Scrollbar for list */\r\n.listContainer::-webkit-scrollbar {\r\n    width: 0.375rem;\r\n}\r\n.listContainer::-webkit-scrollbar-track {\r\n    background: transparent;\r\n}\r\n.listContainer::-webkit-scrollbar-thumb {\r\n    background: #d9d9d9;\r\n    border-radius: 0.25rem;\r\n}\r\n\r\n@keyframes fadeInContent {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(0.5rem);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.driverList {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n    animation: fadeInContent 0.3s ease-out;\r\n}\r\n\r\n.driverCard {\r\n    background-color: white;\r\n    border: 0.0625rem solid #eaeaea;\r\n    border-radius: 0.75rem;\r\n    padding: 0.75rem 1rem;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n    transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.driverCard:hover {\r\n    border-color: #d9d9d9;\r\n    background-color: #fafafa;\r\n}\r\n\r\n.driverAvatar {\r\n    background-color: #f0f0f0;\r\n    color: #595959;\r\n}\r\n\r\n.driverInfo {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.125rem;\r\n}\r\n\r\n.driverName {\r\n    font-weight: 600;\r\n    color: #262626;\r\n    font-size: 0.875rem;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.statusDot {\r\n    width: 0.5rem;\r\n    height: 0.5rem;\r\n    border-radius: 50%;\r\n}\r\n.statusDot.online { background-color: #52c41a; }\r\n.statusDot.withOrder { background-color: #fa8c16; }\r\n.statusDot.offline { background-color: #f5222d; }\r\n\r\n.driverTime {\r\n    font-size: 0.75rem;\r\n    color: #8c8c8c;\r\n}\r\n\r\n.driverTicket {\r\n    font-size: 0.6875rem;\r\n    background-color: #f5f5f5;\r\n    padding: 0.125rem 0.375rem;\r\n    border-radius: 0.25rem;\r\n    color: #595959;\r\n    border: 0.0625rem solid #d9d9d9;\r\n    margin-top: 0.25rem;\r\n    display: inline-block;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 992px) {\r\n    .splitLayout {\r\n        flex-direction: column-reverse;\r\n        gap: 1.5rem;\r\n        height: auto;\r\n        overflow: visible;\r\n    }\r\n    \r\n    .mapContainer {\r\n        width: 100%;\r\n        height: 25rem;\r\n        flex: none;\r\n    }\r\n\r\n    .sidebar {\r\n        width: 100%;\r\n        min-width: 100%;\r\n        height: 31.25rem;\r\n        flex: none;\r\n    }\r\n    \r\n    .filterGrid {\r\n        flex-direction: row;\r\n        overflow-x: auto;\r\n        padding-bottom: 0.5rem;\r\n        -webkit-overflow-scrolling: touch;\r\n    }\r\n    \r\n    .filterCard {\r\n        min-width: 8.75rem;\r\n        flex-shrink: 0;\r\n        flex: none;\r\n        padding: 0.75rem;\r\n    }\r\n    \r\n    .floatingControlsDesktop {\r\n        display: none;\r\n    }\r\n\r\n    .layerControlsMobile {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        gap: 1rem;\r\n        padding: 0.625rem;\r\n        background: #fafafa;\r\n        border-radius: 0.625rem;\r\n        margin-bottom: 1rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `DriversUI_wrapper__obJwE`,
	"header": `DriversUI_header__0BBCu`,
	"back": `DriversUI_back__WLtZC`,
	"loader": `DriversUI_loader__h7qtx`,
	"backButton": `DriversUI_backButton__jK22g`,
	"title-box": `DriversUI_title-box__9p+sj`,
	"splitLayout": `DriversUI_splitLayout__rEdXz`,
	"sidebar": `DriversUI_sidebar__xf6Jk`,
	"mapContainer": `DriversUI_mapContainer__ea6wF`,
	"filterGrid": `DriversUI_filterGrid__Dso5P`,
	"filterCard": `DriversUI_filterCard__lHTlk`,
	"filterCardActive": `DriversUI_filterCardActive__Fd7Qr`,
	"driverCardSelected": `DriversUI_driverCardSelected__XG1dA`,
	"filterCardInfo": `DriversUI_filterCardInfo__lOTkg`,
	"layerControlsMobile": `DriversUI_layerControlsMobile__O74dJ`,
	"floatingControlsDesktop": `DriversUI_floatingControlsDesktop__nnoK9`,
	"layerControl": `DriversUI_layerControl__P4C3A`,
	"layerLabel": `DriversUI_layerLabel__P2qRb`,
	"filterIcon": `DriversUI_filterIcon__9PMIf`,
	"filterTitle": `DriversUI_filterTitle__U3cNH`,
	"filterCount": `DriversUI_filterCount__7cyMT`,
	"filterOnline": `DriversUI_filterOnline__r2V7i`,
	"filterWithOrder": `DriversUI_filterWithOrder__lQWxx`,
	"filterOffline": `DriversUI_filterOffline__qzF3C`,
	"listContainer": `DriversUI_listContainer__UroQD`,
	"driverList": `DriversUI_driverList__PfUJA`,
	"fadeInContent": `DriversUI_fadeInContent__9h25C`,
	"driverCard": `DriversUI_driverCard__ZABXM`,
	"driverAvatar": `DriversUI_driverAvatar__clrK4`,
	"driverInfo": `DriversUI_driverInfo__ljANi`,
	"driverName": `DriversUI_driverName__+qjW7`,
	"statusDot": `DriversUI_statusDot__FdVvJ`,
	"online": `DriversUI_online__0qqpP`,
	"withOrder": `DriversUI_withOrder__W2ePK`,
	"offline": `DriversUI_offline__rYxiW`,
	"driverTime": `DriversUI_driverTime__t9oDC`,
	"driverTicket": `DriversUI_driverTicket__9TwQf`
};
export default ___CSS_LOADER_EXPORT___;
